class CollectionFilters {
  constructor() {
    this.init();
  }

  init() {
    // Only setup filters if we're on a collection or search page
    if (this.isCollectionPage()) {
      // Price filter is handled by Shopify Search & Discovery app
      this.setupColorFilter();
      this.setupVendorFilter();
      this.setupCategoryLinks();
      this.restoreFilterState();
    }
  }

  isCollectionPage() {
    const path = window.location.pathname;
    return path.includes("/collections/") || path === "/search";
  }

  restoreFilterState() {
    // Price filter is handled by Shopify Search & Discovery app
    // Restore color checkboxes from URL
    const urlParams = new URLSearchParams(window.location.search);
    // Handle both comma-separated and multiple parameters
    const colorFilterParam = urlParams.get("filter.v.option.color");
    const colorFilters = colorFilterParam
      ? colorFilterParam.split(",").map((c) => c.trim())
      : urlParams.getAll("filter.v.option.color").map((c) => c.trim());

    if (colorFilters.length > 0) {
      const colorCheckboxes = document.querySelectorAll(
        ".color-filter__checkbox"
      );
      colorCheckboxes.forEach((checkbox) => {
        const checkboxValue = checkbox.value.trim();
        // Match exactly first (case-sensitive), then try case-insensitive
        // This ensures "Orange" matches "Orange" but also handles variations
        const exactMatch = colorFilters.some(
          (filter) => filter === checkboxValue
        );
        const caseInsensitiveMatch = colorFilters.some(
          (filter) => filter.toLowerCase() === checkboxValue.toLowerCase()
        );

        if (exactMatch || caseInsensitiveMatch) {
          checkbox.checked = true;
        }
      });
    }
  }

  // Price filter is now handled by Shopify Search & Discovery app

  // Color Filter
  setupColorFilter() {
    const colorCheckboxes = document.querySelectorAll(
      ".color-filter__checkbox"
    );

    colorCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.applyColorFilter();
      });
    });
  }

  applyColorFilter() {
    const selectedColors = [];
    const colorCheckboxes = document.querySelectorAll(
      ".color-filter__checkbox:checked"
    );

    colorCheckboxes.forEach((checkbox) => {
      const colorValue = checkbox.value.trim();
      if (colorValue) {
        // Use the exact value from the checkbox (preserves original case from Shopify)
        selectedColors.push(colorValue);
      }
    });

    const url = new URL(window.location.href);

    // Remove existing color filters
    // Remove all instances (in case of multiple parameters)
    const keysToRemove = [];
    for (const key of url.searchParams.keys()) {
      if (key === "filter.v.option.color") {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => url.searchParams.delete(key));

    // According to Shopify docs, multiple values can be:
    // 1. Comma-separated in one parameter: filter.v.option.color=red,blue
    // 2. Multiple parameters: filter.v.option.color=red&filter.v.option.color=blue
    // Using comma-separated is simpler and more efficient
    // Note: Shopify's filter system is case-sensitive, so we preserve exact values
    if (selectedColors.length > 0) {
      url.searchParams.set("filter.v.option.color", selectedColors.join(","));
    }

    window.location.href = url.toString();
  }

  // Vendor Filter
  setupVendorFilter() {
    const vendorCheckboxes = document.querySelectorAll(
      '.filter-checkbox[name="vendor"]'
    );

    vendorCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.applyVendorFilter();
      });
    });
  }

  applyVendorFilter() {
    const selectedVendors = [];
    const vendorCheckboxes = document.querySelectorAll(
      '.filter-checkbox[name="vendor"]:checked'
    );

    vendorCheckboxes.forEach((checkbox) => {
      const vendorValue = checkbox.value.trim();
      if (vendorValue) {
        selectedVendors.push(vendorValue);
      }
    });

    const url = new URL(window.location.href);

    // Remove existing vendor filters
    url.searchParams.delete("filter.p.vendor");

    // According to Shopify docs, multiple vendor values can be comma-separated
    if (selectedVendors.length > 0) {
      url.searchParams.set("filter.p.vendor", selectedVendors.join(","));
    }

    window.location.href = url.toString();
  }

  // Category Links (Collections List)
  setupCategoryLinks() {
    // Collection links already work natively, just ensure proper styling
    const currentCollection = window.location.pathname;
    const collectionLinks = document.querySelectorAll(".filter-list__link");

    collectionLinks.forEach((link) => {
      if (link.getAttribute("href") === currentCollection) {
        link.classList.add("active");
      }
    });
  }

  // Helper: Remove filter parameter
  removeFilter(filterKey) {
    const url = new URL(window.location.href);
    // Remove all instances of the filter (in case of multiple values)
    const keysToRemove = [];
    for (const key of url.searchParams.keys()) {
      if (key === filterKey) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => url.searchParams.delete(key));
    window.location.href = url.toString();
  }

  // Clear all filters
  clearAllFilters() {
    const url = new URL(window.location.href);
    const keysToRemove = [];

    for (const key of url.searchParams.keys()) {
      if (key.startsWith("filter.")) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => url.searchParams.delete(key));
    window.location.href = url.toString();
  }
}

// Initialize when DOM is ready
function initCollectionFilters() {
  try {
    new CollectionFilters();
  } catch (error) {
    console.error("Error initializing collection filters:", error);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCollectionFilters);
} else {
  initCollectionFilters();
}

// Also add a clear filters button handler if it exists
document.addEventListener("DOMContentLoaded", () => {
  const clearButton = document.querySelector("[data-clear-filters]");
  if (clearButton) {
    clearButton.addEventListener("click", (e) => {
      e.preventDefault();
      try {
        const filters = new CollectionFilters();
        filters.clearAllFilters();
      } catch (error) {
        console.error("Error clearing filters:", error);
      }
    });
  }
});
